import { SphereIconButton } from "@components/common/sphere-icon-button";
import { Divider, Menu, MenuItem, ThreeDotsIcon } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { useMarkupMoreOptions } from "@pages/project-details/project-markups/use-markup-more-options";
import { PALETTE_VARS } from "@styles/palette-vars";
import { useRef, useState } from "react";

/**
 * Component that represents an action button to give the user more options .
 * Renders an icon button that, when clicked, opens a menu item  that each item render one action.
 *
 * @param markup The properties of the markup to be opened
 * @returns A JSX element representing the action button to give the user more options.
 */
export function MarkupActionMoreOptions({
  markup
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const anchorRef = useRef(null);
  const {
    openMarkup,
    viewDetails,
    shareMarkup,
    canDeleteMarkup,
    requestDeleteMarkup,
    deleteDialog
  } = useMarkupMoreOptions({
    markup
  });

  /** Menu items to be displayed in the VerticalDotsIcon button*/
  const menuItems = [{
    label: "Open in new tab",
    onClick: openMarkup,
    isVisible: true
  }, {
    type: "divider",
    isVisible: true
  }, {
    label: "View details",
    onClick: viewDetails,
    isVisible: true
  }, {
    label: "Share",
    onClick: shareMarkup,
    isVisible: true
  }, {
    label: "Delete",
    onClick: requestDeleteMarkup,
    color: "error.main",
    highlightColor: PALETTE_VARS.error.main,
    isVisible: canDeleteMarkup
  }];
  return <Box sx={{
    display: "inline-block",
    position: "relative"
  }}>
      <SphereIconButton aria-label="more" aria-haspopup="true" component={() => <ThreeDotsIcon sx={{
      width: "18px",
      height: "18px"
    }} />} buttonSize="30px" iconSize="26px" onClick={() => setIsMenuOpen(true)} iconButtonProps={{
      ref: anchorRef,
      sx: {
        marginRight: "10px"
      }
    }} />
      <Menu open={isMenuOpen} anchorEl={anchorRef.current} onClose={() => setIsMenuOpen(false)} anchorOrigin={{
      vertical: "bottom",
      horizontal: "right"
    }} transformOrigin={{
      vertical: "top",
      horizontal: "right"
    }} minWidth="220px" sx={{
      zIndex: 1600
    }}>
        {menuItems.filter(menuItem => menuItem.isVisible).map(item => {
        if (item.type === "divider") {
          return <Divider key="divider" orientation="horizontal" flexItem sx={{
            margin: "4px"
          }} />;
        }
        return <MenuItem key={item.label} label={item.label} onClick={() => {
          setIsMenuOpen(false);
          item.onClick && item.onClick();
        }} color={item.color} highlightColor={item.highlightColor} sx={{
          paddingX: "8px",
          display: "flex",
          alignItems: "center"
        }} />;
      })}
      </Menu>
      {deleteDialog}
    </Box>;
}